import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Appcost(props) {
    return (
        <div className="p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Digital Work">
                            <h2>How Much Does A Digital Marketplace Cost?</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>The cost of building a digital marketplace depends on several parameters such as
                            platform, features, design, and development time. Custom-built platforms are the most
                            expensive, while open-source and SaaS-based platforms can be more affordable.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Appcost;
